import { useEffect, type PropsWithChildren } from 'react';

import { useCurrentUser, useIdToken } from '@/core/store/auth/authSelectors';
import { useFetchCurrentUser } from '@/features/Auth/_utils/useFetchCurrentUser';

import { useRefreshToken } from './_utils/useRefreshToken';
import { SplashScreen } from './SplashScreen/SplashScreen';

const REFRESH_TOKEN_INTERVAL = 1000 * 60 * 13; // 13 minutes

export const Auth = ({ children }: PropsWithChildren) => {
	const { handleTokenRefresh } = useRefreshToken();
	const { loading: loadingUser } = useFetchCurrentUser();
	const idToken = useIdToken();
	const user = useCurrentUser();

	useEffect(() => {
		// Refresh the token on the first visit to the app
		handleTokenRefresh();

		// Subsequent visits (e.g. clicking and being navigated around) will not force the app to refresh the access token.
		const interval = window.setInterval(() => {
			void handleTokenRefresh();
		}, REFRESH_TOKEN_INTERVAL);

		return () => {
			window.clearInterval(interval);
		};
	}, [handleTokenRefresh]);

	// Note (Ben): Only show splashscreen if user is logged in but doesn't yet have 'currentUser'
	if (idToken && loadingUser && !user) {
		return <SplashScreen />;
	}

	return <>{children}</>;
};
